'use strict';

module.exports = {
  // Initialize breadcrumb behavior on window load
  init: function () {
    $(window).on('load', function() {
      var $breadcrumbs = $('.mm-breadcrumb, .mm6-breadcrumb');

      if ($breadcrumbs.length === 0) return;

      var isUpdating = false;

      // Function to recalculate and apply collapse/expand logic for a given breadcrumb list
function updateBreadcrumb($ul, $parent) {
        if ($ul.length === 0) return;
        var breadcrumbsLength = $ul.find('.mm-breadcrumb-item, .mm6-breadcrumb-item').length;

        // Reset states
        $ul.removeClass('is-l1-collapsed is-l2-collapsed');

        // Ideal measurement (requiredSpace)
        $ul.css('width', 'max-content');
        var requiredSpace = Math.ceil($ul.outerWidth());
        // Reset width to allow normal layout after measurement
        $ul.css('width', '');

        // Calculate available space based on .js-header__left container (fallback to parent) and its siblings
        var $container = $ul.closest('.js-header-left');
        if ($container.length === 0) {
          $container = $ul.closest('.js-breadcrumbs-wrapper');
        }
        if ($container.length === 0) {
          return;
        }

        var containerWidth = $container.width();
        var $headerLeft = $container.find('.js-header-left-block');
        var siblingsWidth = 0;
        var gapsWidth = 0;

        if ($headerLeft.length > 0) {
          siblingsWidth = $headerLeft.children()
            .not($('.js-breadcrumbs-wrapper'))
            .toArray()
            .reduce(function (sum, el) {
              return sum + $(el).outerWidth(true);
            }, 0);

          // outerWidth(true) covers margins but NOT the flex column-gap between
          // the header-left children (gap-x-desk(1) = 1ch). Without this the
          // available space is overestimated by (children - 1) * gap and the
          // breadcrumb truncates a few px too late.
          var cs = window.getComputedStyle($headerLeft[0]);
          var gapPx = parseFloat(cs.columnGap || cs.gap || '0');
          var childCount = $headerLeft.children().length;
          if (!isNaN(gapPx) && childCount > 1) {
            gapsWidth = gapPx * (childCount - 1);
          }
        }
        var availableSpace = Math.max(0, Math.floor(containerWidth - siblingsWidth - gapsWidth));

        // Cascading truncation logic
        if (requiredSpace > availableSpace) {
          $ul.addClass('is-l1-collapsed');
          var currentScrollWidth = Math.ceil($ul[0].scrollWidth);
          if (currentScrollWidth > availableSpace && breadcrumbsLength > 2) {
            $ul.addClass('is-l2-collapsed');
          }
        }
      }

      // Observe breadcrumb container resizing to trigger updates
      var observer = new ResizeObserver(function (entries) {
        if (isUpdating) return;

        window.requestAnimationFrame(function () {
          isUpdating = true;
          entries.forEach(function (entry) {
            var $parent = $(entry.target);
            var $ul = $parent.find('.mm-breadcrumb, .mm6-breadcrumb');
            updateBreadcrumb($ul, $parent);
          });
          isUpdating = false;
        });
      });

      // Observe each breadcrumb container's parent
      $breadcrumbs.each(function () {
        var parent = $(this).parent()[0];
        if (parent) {
          observer.observe(parent);
        }
      });

      // Also handle window resize to re‑evaluate after expansion
      window.addEventListener('resize', function () {
        $breadcrumbs.each(function () {
          var $parent = $(this).parent();
          var $ul = $parent.find('.mm-breadcrumb, .mm6-breadcrumb');
          updateBreadcrumb($ul, $parent);
        });
      });
    });
  }
};
